<template>
  <div id="about-area" class="about-area pd-top-90">
    <div class="container">
      <div class="container">
        <div class="row">
          <div
            class="col-xl-4 col-lg-9 mt-3 mt-xl-0 align-self-center section-title"
          >
            <h6 class="sub-title">¿Quiénes somos?</h6>
            <p style="text-align: justify;">
              En Smaco, nos dedicamos a ofrecer soluciones de software
              innovadoras y personalizadas para satisfacer las necesidades de tu
              negocio. Nuestro enfoque centrado en el cliente y nuestra
              experiencia en desarrollo de software nos permiten brindarte
              soluciones de alta calidad que impulsen el éxito y la eficiencia
              de tu empresa.
            </p>
            <div class="btn-wrap">
              <router-link to="/about" class="btn btn-border-base"
                >Más acerca de nosotros</router-link
              >
            </div>
          </div>
          <div class="col-xl-7 col-lg-9">
            <img
              :src="require('@/assets/img/bg/smaco-7.jpg')"
              alt="img"
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      showPopup: false
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/page/home/About.vue